/**
 * if value is true/True/TRUE
 */
export function isTrue(value) {
    if (value === true ||
        value === 'true' ||
        value === 'True' ||
        value === 'TRUE') {
        return true;
    }
    return false;
}
//# sourceMappingURL=IsTrue.js.map